import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useUpdateReview, useDeleteReview } from './useAlbumReviews';

const useMyReviewActions = (review, options = {}, overrides = {}) => {
  const { albumSlug, albumSource: paramSource, sourceId: paramId } = useParams();
  const navigate = useNavigate();
  const { redirectAfterDelete = true } = options;
  const albumSource = overrides.albumSource || paramSource;
  const sourceId = overrides.sourceId || paramId;
  const albumUrl =
    options.returnAlbumUrl ||
    (albumSlug ? `/reviews/${albumSlug}` : `/reviews/${albumSource}/${sourceId}`);

  const [isEditing, setIsEditing] = useState(false);
  const [editFormData, setEditFormData] = useState({ rating: 0, content: '' });

  const updateReview = useUpdateReview(albumSource, sourceId);
  const deleteReview = useDeleteReview(albumSource, sourceId);

  const handleEdit = () => {
    if (review) {
      setEditFormData({ rating: review.rating, content: review.content });
      setIsEditing(true);
    }
  };

  const handleCancel = () => {
    if (review) {
      setEditFormData({ rating: review.rating, content: review.content });
    }
    setIsEditing(false);
  };

  const handleSubmit = async (formData) => {
    if (!review) return;
    await updateReview.mutateAsync({
      albumId: sourceId,
      reviewId: review.id,
      content: formData.content,
      rating: formData.rating,
    });
    setIsEditing(false);
  };

  const handleDelete = async () => {
    if (!review) return;
    try {
      await deleteReview.mutateAsync({
        albumId: review.albumId || sourceId,
        reviewId: review.id,
      });
      setEditFormData({ rating: 0, content: '' });
      setIsEditing(false);
      if (redirectAfterDelete) {
        navigate(albumUrl);
      }
    } catch (error) {
      console.error('Failed to delete review:', error);
    }
  };

  return {
    isEditing,
    editFormData,
    setEditFormData,
    handleEdit,
    handleCancel,
    handleSubmit,
    handleDelete,
  };
};

export default useMyReviewActions;
